export const METADATA = {
  sejour: {
    title: 'Offres de séjours XX',
    h1: 'Séjours XX, vacances et offres promos à réserver',
    meta: 'Réservation en ligne de séjours XX : circuits, packages, vacances, clubs,...préférés des voyageurs',
  },
  activity: {
    title: 'Activités XX',
    h1: 'Meilleures activités et expériences XX',
    meta: 'Expériences à réserver en ligne XX : loisirs, activités, tours, transports touristiques, ateliers',
  },
  hotel: {
    title: 'Hôtels XX',
    h1: 'Hôtels XX : sélection des meilleurs hôtels XX',
    meta: 'Meilleurs prix et promos hôtels XX à réserver en ligne pas cher, avec piscine ou spa, de luxe, familial, de charme...plebiscités par les voyageurs visitant XX',
  },
  flight: {
    title: 'Vols XX',
    h1: 'Réservation de vol XX - Comparateur de prix',
    meta: "Comparez les prix des compagnies aériennes XX pour obtenir le meilleur prix pour votre billet d'avion XX",
  },
  rental: {
    title: 'Locations vacances XX',
    h1: 'Locations vacances XX : gites, chambres hotes, appartements, b & b',
    meta: 'Comparateur et réservation de locations de vacances XX : villas, maison, gites, chambres hotes, appartements, bed & breakfast',
  },
  event: {
    title: 'Evénements, ateliers, concerts, expos et spectacles XX',
    h1: 'XX événements, ateliers, concerts, expos et spectacles',
    meta: 'Réservez en ligne pour votre prochain événement, loisirs, atelier, concerts ou spectacle XX',
  },
  cruise: {
    title: 'Croisières XX',
    h1: 'Réservation en ligne de croisières XX',
    meta: 'Comparer les prix des croisières en ligne XX',
  },
  other: {
    title: 'Sechapper.com',
    h1: 'XX',
    meta: 'Réservation de voyages XX avec Sechapper.com',
  },
};
